

































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import auth from '@/api/auth';
import Header from '@/components/header.vue';
import { getUserProductList } from '@/utils/fliter-pression';
@Component({
    components: {
        Header,
    },
    computed: mapState({
        realRouter: (state:any) => state.realRouter,
        product: (state:any) => state.product,
    }),
})
export default class Home extends Vue {
  private productList: Array<string> = [];

  goLink(product:string) {
      this.$store.dispatch('GETSIDER', product).then((res) => {
          if (res[0].children && res[0].children.length > 0) {
              this.$router.push({ name: res[0].children[0].name });
          } else {
              this.$router.push({ name: res[0].name });
          }
      });
  }

  hasLimit(target:string) {
      if (target) {
          return this.productList.indexOf(target) !== -1;
      }
      return false;
  }

  created() {
      const real = this.$store.state.realRouter;
      this.productList = this.$store.state.product;
      if (real.length <= 0) {
          auth().then((res:any) => {
              if (res.data.status === 1) {
                  const userName = res.data.data && res.data.data.user;
                  this.$store.commit('setUser', userName);
                  this.$store.dispatch('GETPRESSION', res.data.data.products).then((resp) => {
                      this.productList = getUserProductList(resp);
                  });
              } else if (res.data.data && res.data.data.link) {
                  this.$router.push({ path: `/${res.data.data.link}` });
              } else {
                  this.$router.push({ path: '/crash' });
              }
          });
      }
  }
}
